class TabGroup extends HTMLElement {
  connectedCallback() {
    this.tabs = [...this.querySelectorAll('[data-trigger]')];
    this.panels = [...this.querySelectorAll('[data-panel]')];

    this.tabs.forEach((tab, index) => {
      tab.addEventListener('click', () => this.select(index));
      tab.addEventListener('keydown', (e) => {
        const step = { ArrowRight: 1, ArrowLeft: -1 }[e.key];
        if (!step) return;
        e.preventDefault();
        const next = (index + step + this.tabs.length) % this.tabs.length;
        this.select(next);
        this.tabs[next].focus();
      });
    });
  }

  select(index) {
    this.tabs.forEach((tab, i) => {
      const active = i === index;
      tab.setAttribute('aria-selected', active);
      tab.tabIndex = active ? 0 : -1;
      this.panels[i].hidden = !active;
    });
  }
}

customElements.define('tab-group', TabGroup);
